/**
 * <k-sticky-buy>: mobile bar that slides up once the main product form scrolls out of view.
 * Its button clicks the page's real Add to cart button, so the selected variant, quantity and
 * cart drawer all work as normal. If the product can't be added (sold out), it scrolls back to the form.
 */
class KStickyBuy extends HTMLElement {
  #observer = null;
  #bar = null;
  #button = null;

  #onClick = () => {
    const form = document.querySelector('[data-product-form]');
    const addButton = form?.querySelector('button[name="add"]:not([disabled])');
    if (addButton) {
      addButton.click();
      return;
    }
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    form?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
  };

  connectedCallback() {
    this.#bar = this.querySelector('[data-sticky-bar]');
    this.#button = this.querySelector('[data-sticky-add]');
    const form = document.querySelector('[data-product-form]');
    if (!this.#bar || !this.#button || !form) return;

    this.#button.addEventListener('click', this.#onClick);
    this.#observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.#bar.toggleAttribute('data-visible', scrolledPast);
      this.#bar.inert = !scrolledPast;
    });
    this.#observer.observe(form);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#button?.removeEventListener('click', this.#onClick);
  }
}

if (!customElements.get('k-sticky-buy')) {
  customElements.define('k-sticky-buy', KStickyBuy);
}
